<section class="header">
  <img src="./assets/img/icon_mailinfo.png" alt="" class="largeImageIcon">
  <div class='screenTitle'>
    <h1>{{'CONTACTINFO.TITLE' | translate}}</h1>
    <span class='titleDescription'>{{'CONTACTINFO.DESCRIPTION' | translate}}</span>
  </div>

</section>

<mat-card class="lg-form-card d-flex flex-column align-items-center mat-elevation-z8">
  <section class="lg-card-header d-flex justify-content-start align-items-start">
    <div id="map"></div>
    <div class="info d-flex flex-column ">
      <p class='address'><strong>{{userData?.addresseeName}}</strong><br>
        {{userData?.addressLine1}}<br>
        {{userData?.addressLine2}}</p>
      <p class='guid'><span>Envío {{userData?.GUID}}</span><br>
        <span *ngIf="userData.externalId!=''">External ID: {{userData?.externalId}}</span><br>
        <span *ngIf="userData.billingInfo!=''">Centro de coste: {{userData?.billingInfo}}</span><br></p>
    </div>
  </section>

  <mat-card-content class="w-100 px-4">
    <form [formGroup]="signInForm" class="d-flex flex-column">
      <div class="form-group row">
        <label for="email" class="col-sm-3 col-form-label">{{'FORM.ADDRESSEE_EMAIL' | translate}}<span *ngIf="userData?.addresseeEmailRequired" class="required-marker">*</span></label>
        <div class="col-sm-9">
          <input formControlName="email" class="form-control" type="email" name="email" value="{{userData?.addresseeEmail}}">
        </div>
      </div>
      <div class="form-group row">
        <label for="phone" class="col-sm-3 col-form-label">{{'FORM.ADDRESSEE_MOBILE' | translate}}<span *ngIf="userData?.addresseePhoneRequired" class="required-marker">*</span></label>
        <div class="col-sm-9">
          <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true"
            [phoneValidation]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.Spain" [maxLength]="15"
            [phoneValidation]="true" [separateDialCode]="separateDialCode"
            [numberFormat]="PhoneNumberFormat.International" name="phone" formControlName="phone">
          </ngx-intl-tel-input>
        </div>
      </div>
      <div *ngIf="errors?.addresseeEmail" class="d-flex justify-content-start align-items-center">
        <mat-icon color="accent" mat-list-icon>error</mat-icon>
        <span class="error-msg">{{errors?.addresseeEmail}}</span>
      </div>
      <div *ngIf="errors?.addresseePhone" class="d-flex justify-content-start align-items-center">
        <mat-icon color="accent" mat-list-icon>error</mat-icon>
        <span class="error-msg">{{errors?.addresseePhone}}</span>
      </div>
      <div class='legal'>{{'FORM.CONSENT1' | translate}} <a href="{{'NAVBAR.PRIVACYLINK' | translate}}" target="_blank">{{'NAVBAR.PRIVACY' | translate}}</a> {{'FORM.CONSENT2' | translate}}</div>
      <div lgRecaptcha key="6LdqXH0aAAAAAMXirKLo3PuxrqzcP9wbWXayYNNP" [submit]="submit"></div>
        <div *ngIf="!emailField?.valid && emailField?.touched" class="d-flex justify-content-start align-items-center">
        <mat-icon color="accent" mat-list-icon>error</mat-icon>
        <span class="error-msg">Verifica haber completado un e-mail válido</span>
      </div>
      <div *ngIf="!phoneField?.valid && phoneField?.touched" class="d-flex justify-content-start align-items-center">
        <mat-icon color="accent" mat-list-icon>error</mat-icon>
        <span class="error-msg">Verifica haber completado un teléfono válido</span>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button mat-flat-button color="primary" [disabled]="signInForm.invalid || disableSubmit"
      (click)="executeChallenge()"> <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"
        aria-hidden="true"></span>
        {{'FORM.SUBMIT' | translate}}</button>
  </mat-card-actions>

</mat-card>